import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Password } from "primereact/password";

export default function CompanyForm({
  isOpen,
  onClose,
  onSubmit,
  initialData,
  currents,
  users,
}) {
  const [formData, setFormData] = useState({
    userId: 0,
    currentId: 0,
    address: "",
    notes: "",
    gender: 0,
    fullName: "",
    email: "",
    mobilePhones: "",
    status: true,
    password: "",
    groupId:2,
    birthDate: new Date().toISOString(),
    recordDate: new Date().toISOString(),
    updateContactDate: new Date().toISOString(),
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {setErrors({}); 
    if (initialData) { 
      setFormData(initialData);
    } else {
      const newPassword = generateRandomPassword();
      setFormData({
        userId: 0,
        currentId: 0,
        address: "",
        notes: "",
        gender: 0,
        fullName: "",
        email: "",
        mobilePhones: "",
        status: true,
        groupId:2,
        password: newPassword,
        birthDate: new Date().toISOString(),
        recordDate: new Date().toISOString(),
        updateContactDate: new Date().toISOString(),
      });
    }
  }, [initialData]);
 

  const generateRandomPassword = (length = 12) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  const handleGeneratePassword = (e) => {
    e.preventDefault();
    const newPassword = generateRandomPassword();
    setFormData({ ...formData, password: newPassword });
  };

  const validateForm = () => {
    const newErrors = {}; 
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Boş bırakılamaz.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Boş bırakılamaz.";
    }
      if(!initialData){
        var user = users.find(u=>u.email === formData.email);
        if(user){
         newErrors.email = "Bu email adresi kullanılmaktadır.";
        } 
  }
    if(!initialData){
      if (!formData.password) {
        newErrors.password = "Boş bırakılamaz.";
      }
    }
   

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Hata yoksa true döner
  };

  const handleChange = (name, value) => {
    setErrors({ ...errors, [name]: null }); 
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setFormData({ ...formData, [name]: value });

  };

  const handleSubmit = (e) => {
    e.preventDefault();   
    if (validateForm()) {
      onSubmit(formData); 
   
    }
  };
  const footer = () => {
    return (
      <div className=" flex  w-full m-0">
        <div className="p-d-flex p-jc-end col-12 ">
          <Button
            className="w-full "
            label={initialData ? "Güncelle" : "Kaydet"}
            icon= "pi pi-check"
            severity={initialData ? "info" : "success"}
            outlined
            onClick={handleSubmit}
          />
        </div>
      </div>
    );
  };
  return (
    <Dialog
      className="max-w-full w-11 md:w-11  xl:w-8  "
      visible={isOpen}
      footer={footer()}
      onHide={onClose}
      header={initialData ? "Kullanıcı Görüntüle" : "Yeni Kullanıcı"}
    >
      <form className="  grid mt-3  ">
        <div className="col-12  ">
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Cari</span>
            <Dropdown
              id="currentId"
              name="currentId"
              value={formData.currentId}
              filter
              options={
                currents
                  ? currents.map((current) => ({
                      label: current.unvan, // Görüntülenecek metin
                      value: current.id, // Seçim yapılacak değer
                    }))
                  : [] // currents yüklenmemişse boş bir dizi
              }
              emptyMessage="Cari bulunamadı"
              emptyFilterMessage="Cari bulunamadı"
              onChange={(e) => handleDropdownChange("currentId", e.value)}
            />
          </div>
        </div>
        <div className={`col-12  ${formData.currentId !== 0 && "hidden"} `}>
          <div className="flex justify-content-center flex-wrap">
            <span>İşlem yapabilmek için önce Cari Seçiniz.</span>
            <i className=" pi pi-angle-up" style={{ color: "green" }}></i>
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"} `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Ad Soyad</span>
            <InputText
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={(e) => handleChange("fullName", e.target.value)}
            />
          
              
              {errors.fullName && (  <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.fullName}</small>
              </span> )}
           
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"} `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Email</span>
            <InputText
              id="useremail"
              name="useremail"
              value={formData.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          
              
              {errors.email && (  <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.email}</small>
            </span>  )}
            
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"} ${
            initialData && "hidden"
          } `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Şifre</span>
            <Password
              id="userpassword"
              name="userpassword"
         feedback = {false}
              value={formData.password}
              onChange={(e) => handleChange("password", e.target.value)}
              weakLabel="Kolay"
              mediumLabel="Orta"
              strongLabel="Zor"
              toggleMask  
              promptLabel="Güçlü şifrenizi giriniz."
              inputStyle={{
                width: "100%",
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius:  0,
                borderTopRightRadius:  0,
              }}
              pt={{ iconField: { root: { className: "w-full" } } }}
            />
            
           <Button
          label="Üret"
          icon="pi pi-refresh"
          onClick={handleGeneratePassword}
          severity="info"
        />
              
              {errors.password && (  <span className="p-inputgroup-addon max-w-max">
                <small className="p-error">{errors.password}</small>
                </span> )}
          
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"} `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Adres</span>
            <InputText
              id="address"
              name="address"
              value={formData.address}
              onChange={(e) => handleChange("address", e.value)}
            />
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"} `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Telefon</span>
            <InputText
              id="mobilePhones"
              name="mobilePhones"
              value={formData.mobilePhones}
              onChange={(e) => handleChange("mobilePhones", e.value)}
            />
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"} `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Not</span>
            <InputText
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={(e) => handleChange("notes", e.value)}
            />
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"} `}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem">Cinsiyet</span>
            <Dropdown
              id="gender"
              name="gender"
              value={formData.gender}
              options={[
                { label: "Erkek", value: 0 },
                { label: "Kadın", value: 1 },
              ]}
              onChange={(e) => handleDropdownChange("gender", e.value)}
            />
          </div>
        </div>
        <div
          className={`col-12 md:col-6 ${formData.currentId === 0 && "hidden"}   ${
            initialData && "hidden"
          }`}
        >
          <div className="p-inputgroup flex-1 w-12    ">
            <span className="p-inputgroup-addon w-7rem ">Durum</span>
            <Dropdown
              id="status"
              name="status"
              value={formData.status}
              options={[
                { label: "Aktif", value: true },
                { label: "Pasif", value: false },
              ]}
              onChange={(e) => handleDropdownChange("status", e.value)}
            />
          </div>
        </div>
        <div
          className={`col-12   ${formData.currentId === 0 && "hidden"}   ${
            initialData && "hidden"
          }`}
        >
                  <div className="p-inputgroup flex-1 w-12    ">
                    <span className="p-inputgroup-addon w-7rem">Yetki</span>
                    <Dropdown
                      id="groupId"
                      name="groupId"
                      value={formData.groupId}
                      options={[
                        { label: "Sistem Admin", value: 1 },
                        { label: "Cari Admin", value: 2 },
                        { label: "Cari Kullanıcı", value: 3 },
                      ]}
                      onChange={(e) => handleDropdownChange("groupId", e.value)}
                    />
                   
                    {errors.groupId && (
                      <span className="p-inputgroup-addon max-w-max">
                        <small className="p-error">{errors.groupId}</small>
                      </span>
                    )}
                  </div>
                </div>
      </form>
    </Dialog>
  );
}
